import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
            colors: colors
        },
        dark: localStorage.getItem('theme') == 'dark' ? true : false,
        themes: {
            light: {
                primary: '#8BC34A', //colors.lightGreen,
                secondary: '#03A9F4', //colors.lightBlue,
                accent: colors.orange,
                warning: colors.deepOrange,
                error: colors.red,
            },
            dark: {
                primary: '#8BC34A', //colors.lightGreen,
                secondary: '#03A9F4', //colors.lightBlue,
                accent: colors.orange,
                warning: colors.deepOrange,
                error: colors.red,
            },
        },
    },
});
